export const inputs = {
  all: css => css`
    ::selection {
      background-color: #E3E0F3;
    }

  textarea {
    width: 100%;
    height: calc(3 * var(--input-height));
    min-height: var(--input-height);
    border: var(--input-border);
    box-shadow: var(--input-shadow);
    font-size: var(--input-font-size);
    font-weight: var(--input-font-weight);
    color: var(--input-fg);
    background: var(--input-bg);
    border-radius: var(--input-radius);
    resize: none;
    padding: 2rem;
    box-sizing: border-box;
    font-family: inherit;
  }
    
  input[type='date']::-webkit-inner-spin-button,
  input[type='month']::-webkit-inner-spin-button,
  input[type='month']::-webkit-calendar-picker-indicator {
    color: transparent;
    background: none;
    z-index: 1;
  }
  input[type='file'] {
    display: none;
  }

  ul[role='listbox'] {
    max-height: 26rem;
    overflow-y: auto;
    line-height: 3rem;
    padding: 1.5rem;
    box-sizing: border-box;
    list-style-type: none;
    height: auto;
  }

  input,
  ul[role='listbox'] {
    font-family: var(--font-family);
    background: var(--input-bg);
    font-size: var(--input-font-size);
    border-radius: var(--input-radius);
    outline: var(--input-outline);
    border: var(--input-border);
    width: 100%;
    text-align: inherit;
    box-sizing: border-box;
    padding: var(--input-padding);
    box-shadow: var(--input-shadow);
  }

  input {
    color: var(--input-fg);
    font-weight: var(--input-font-weight);
    height: var(--input-height);
    padding-inline-start: 2.2rem;
  }

  input[type='date'], input[type="month"] {
    text-align: center;
    padding-inline-start: 5rem;
  }

  input::placeholder {
    color: var(--text-disabled);
  }

  input:focus::placeholder {
    opacity: 0.2;
  }
  `,
  mobile: css => css``,

  desktop: css => [
    inputs.all(css),
    css``],
};